import type { FaireProductEntity } from "../../entity_types/product";

export const p_ufvgqqra5q: FaireProductEntity = {
  token: "p_ufvgqqra5q",
  type: "product",
  name: "Hot Is A State Of Mind Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/b6afd14f86e54154d52729cc4c1f646cdfcc131516c2e36a5fdeb6dae709b276.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be2a3fceb185e6920d5438f0e68593e023a1b7c009a91cf7beb01bf217260482.jpeg",
    "https://cdn.faire.com/fastly/de34ab99d0c4dd6d7de4227ed8cb12174723ed7588e5b6973683689e693872a6.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/601321d162f90e2cbe05489d481cefb3aa408e7559e31a1d5378824eae884773.jpeg",
    "https://cdn.faire.com/fastly/e3f125efc084c1f5b9eeb8b99f04ab7bfd13f151508c028d9eeaba0ed8d3c21e.jpeg",
    "https://cdn.faire.com/fastly/1f69965da62471da1e503b36ba080ba37e0e724624795bbc4e37ad23ffea406c.jpeg",
    "https://cdn.faire.com/fastly/ce8618aef34957aceeaf21729e42e48f10965d7db2e1ac78702cbd3d7297ba0f.jpeg"
  ],
  priceDollars: 9.6,
  description: "A grip sock for embracing the sweat and the sexy ~ in equal measure. 🧘\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:20.126Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
